import { type ActiveState, createEntityStore, type EntityState } from '@datorama/akita';
import { type KPI } from 'types/models';

export interface KPIsState extends EntityState<KPI>, ActiveState {}

const store = createEntityStore<KPIsState>({}, { resettable: true, name: 'kpis' });

export default store;
